import HomePage from "@/views/HomePage.vue";
import DashboardPage from "@/views/Dashboard.vue";
import SignedPage from "@/views/Signed.vue";
import { Routes } from "@/generated/router/routes";
import Redirection from "@/components/Redirection.vue";
import { Fiches } from "@/generated/classes/AppSchema";
import PaymentStatus from "@/views/PaymentStatus.vue";


const routes = Routes;

routes.push(
  {
    path: "/",
    name: "HomePage",
    component: HomePage
  },
  {
    path: "/subscribe",
    name: "Subscribe",
    component: HomePage
  },
  {
    path: "/login",
    name: "Login",
    component: HomePage
  },
  {
    path: "/loginParam",
    name: "LoginParam",
    props: { fiche: Fiches.PREFERENCE },
    component: Redirection
  },
  {
    path: "/subscribe",
    name: "subscribe",
    component: DashboardPage
  },
  {
    path: "/connect",
    name: "Connect",
    component: DashboardPage
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardPage
  },
  {
    path: "/signed",
    name: "Signed",
    component: SignedPage
  },
  {
    path: "/payment-status",
    name: "PaymentStatus",
    component: PaymentStatus
  }
)
export default routes;
